<template>
  <el-autocomplete
  ref="SearchInput"
  class="NavBarRightSearch"
  v-model="searchQuery"
  popper-class="NavBarRightSearch__results scrollbar-container"
  placeholder="Search"
  prefix-icon="el-icon-search"
  placement="bottom-end"
  :select-when-unmatched="true"
  :trigger-on-focus="true"
  :popper-append-to-body="false"
  :debounce="250"
  :fetch-suggestions="querySearch"
  @select="select">
    <template
    slot-scope="{ item }"
    class="NavBarRightSearch__result">
      <span
      v-if="item.type > -1"
      class="NavBarRightSearch__thumbnail"
      :style="{ 'background-image': 'url('+thumbnailPlaceholder(item.type)+')'}"/>
      <i v-else class="el-icon-search NavBarRightSearch__thumbnail"/>
      <span class="NavBarRightSearch__name">{{ item.name }}</span>
    </template>
  </el-autocomplete>
</template>

<script>
import FileMixin from '@/components/mixins/File.mixin'
import { mapActions } from 'vuex'

export default {
  name: 'NavBarRightSearch',

  mixins: [
    FileMixin
  ],

  data () {
    return {
      searchQuery: ''
    }
  },

  methods: {
    ...mapActions('search', [
      'getSearchResults',
      'setSearchFiles'
    ]),
    querySearch (searchQuery, cb) {
      const params = { searchPhrase: searchQuery }
      this.getSearchResults(params)
        .then(({ items, nextToken }) => {
          cb(this.prepareItems(items, searchQuery))
        }).catch(() => {})
    },
    prepareItems (items, searchQuery) {
      if (!searchQuery) return []
      let results = []
      switch (items.length) {
        case 0:
          results.push({
            name: `No search results for "${searchQuery}"`,
            type: -1,
            searchQuery
          })
          break
        default:
          results.push({
            name: `Show all results for "${searchQuery}"`,
            type: -1,
            searchQuery
          })
          results.push(...items)
          break
      }
      return results
    },
    select (item) {
      const el = this.$refs.SearchInput
      if (el && el.$children[0]) el.$children[0].blur()

      if (item.type > -1) this.handleSelect(item)
      else if (item.searchQuery) {
        this.goToSearch(item.searchQuery)
      } else if (item.value) {
        this.goToSearch(item.value)
      }
    },
    goToSearch (searchQuery) {
      const searchString = encodeURIComponent(searchQuery)
      this.$router.push({ path: `/search/${searchString}` })
    }
  }
}
</script>

<style lang="scss">
@import 'NavBarRightSearch';
</style>
